import(/* webpackMode: "eager" */ "/home/interim/frontend/app/training/page.tsx");
